module.exports = __webpack_public_path__ + "img/bg-new-4.84a20338.png";